(function () {
  function parseStatLabel(text) {
    var raw = (text || '').trim();
    var suffixMatch = raw.match(/([^0-9.,\s]+)$/);
    var suffix = suffixMatch ? suffixMatch[1] : '';
    var numPart = raw.replace(/[^0-9.]/g, '');
    var target = parseFloat(numPart);
    var useCommas = raw.indexOf(',') !== -1;

    return {
      target: target,
      suffix: suffix,
      useCommas: useCommas,
      valid: !isNaN(target),
    };
  }

  function formatValue(value, useCommas) {
    var rounded = Math.round(value);
    return useCommas ? rounded.toLocaleString('en-US') : String(rounded);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateStat(el, duration) {
    if (el.dataset.qeviqAnimated === 'true') return;
    el.dataset.qeviqAnimated = 'true';

    var parsed = parseStatLabel(el.dataset.qeviqStatRaw);
    if (!parsed.valid) return;

    var valueNode = el.querySelector('.qeviq-stat-number__value');
    var suffixNode = el.querySelector('.qeviq-stat-number__suffix');
    if (!valueNode) return;

    if (suffixNode) suffixNode.textContent = parsed.suffix;

    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var current = parsed.target * easeOutCubic(progress);
      valueNode.textContent = formatValue(current, parsed.useCommas);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        valueNode.textContent = formatValue(parsed.target, parsed.useCommas);
      }
    }

    requestAnimationFrame(step);
  }

  function initRoot(root) {
    if (!root || root.dataset.qeviqStatsBound === 'true') return;
    root.dataset.qeviqStatsBound = 'true';

    var duration = 1600;
    var durationVar = getComputedStyle(root).getPropertyValue('--qeviq-count-duration').trim();
    if (durationVar) {
      duration = parseFloat(durationVar) || 1600;
    }

    var stats = root.querySelectorAll('[data-qeviq-stat]');
    if (!stats.length) return;

    stats.forEach(function (stat) {
      var parsed = parseStatLabel(stat.dataset.qeviqStatRaw);
      var suffixNode = stat.querySelector('.qeviq-stat-number__suffix');
      if (suffixNode && parsed.valid) {
        suffixNode.textContent = parsed.suffix;
      }
    });

    if (!('IntersectionObserver' in window)) {
      stats.forEach(function (stat) {
        animateStat(stat, duration);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateStat(entry.target, duration);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -5% 0px' }
    );

    stats.forEach(function (stat) {
      observer.observe(stat);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-qeviq-stats-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-qeviq-stats-root]');
    if (!root) return;

    root.dataset.qeviqStatsBound = 'false';
    root.querySelectorAll('[data-qeviq-stat]').forEach(function (stat) {
      stat.dataset.qeviqAnimated = 'false';
      var valueNode = stat.querySelector('.qeviq-stat-number__value');
      if (valueNode) valueNode.textContent = '0';
    });
    initRoot(root);
  });
})();
